import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.95964 4.93827V17.0216H16.043V4.93827H3.95964ZM2.29297 4.72994C2.29297 3.92452 2.94589 3.27161 3.7513 3.27161H16.2513C17.0567 3.27161 17.7096 3.92452 17.7096 4.72994V17.2299C17.7096 18.0354 17.0567 18.6883 16.2513 18.6883H3.7513C2.94589 18.6883 2.29297 18.0354 2.29297 17.2299V4.72994Z",
      fill: "#6E0AFA"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.7597 10.8641C7.08514 10.5386 7.61278 10.5386 7.93821 10.8641L10.0006 12.9265L12.063 10.8641C12.3884 10.5386 12.9161 10.5386 13.2415 10.8641C13.5669 11.1895 13.5669 11.7171 13.2415 12.0426L10.5899 14.6942C10.4336 14.8505 10.2216 14.9383 10.0006 14.9383C9.77959 14.9383 9.56762 14.8505 9.41134 14.6942L6.7597 12.0426C6.43427 11.7171 6.43427 11.1895 6.7597 10.8641Z",
      fill: "#6E0AFA"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.0013 7.02161C10.4615 7.02161 10.8346 7.3947 10.8346 7.85494V14.1049C10.8346 14.5652 10.4615 14.9383 10.0013 14.9383C9.54106 14.9383 9.16797 14.5652 9.16797 14.1049V7.85494C9.16797 7.3947 9.54106 7.02161 10.0013 7.02161Z",
      fill: "#6E0AFA"
    }, null, -1)
  ])))
}
export default { render: render }